import { Checkbox, FormControlLabel, Typography } from "@material-ui/core"
import { Add } from "@material-ui/icons"
import PropTypes from "prop-types"
import React, { useContext, useMemo, useState } from "react"
import { useMutation } from "react-query"
import { updateAppCourseTestUsers } from "~/actions/users"
import ListTitle from "~/components/Common/ListTitle"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import DebouncedSearch from "~/components/DebouncedSearch"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import TestUserCard from "~/components/Users/TestUserCard"
import AppContext from "~/contexts/App"
import CourseContext from "~/contexts/Course"
import Page from "~/pages/Page"
import Router from "~/router"
import Box from "../../../../../../components/Common/Box"
import useStyles from "./styles"

const TestUser = ({ routes = [], ...rest }) => {
  const [showAssigned, setShowAssigned] = useState(false)
  const classes = useStyles()

  const { openSnackBar } = useContext(AppContext)

  const course_id = +rest?.match?.params?.course_id

  const { listAppTestUsersQuery } = useContext(CourseContext)

  const [searchValue, setSearchValue] = useState("")

  const testUsers = useMemo(() => {
    if (!listAppTestUsersQuery.data?.data) {
      return []
    } else {
      return listAppTestUsersQuery.data.data.filter((testUser) => {
        if (!testUser.first_name || !testUser.last_name) {
          return false
        }
        if (showAssigned && testUser.assigned === false) {
          return false
        }

        return (
          testUser.first_name
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          testUser.last_name
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          testUser.email.toLowerCase().includes(searchValue.toLowerCase())
        )
      })
    }
  }, [listAppTestUsersQuery, searchValue, showAssigned])

  const testUsersAssigned = useMemo(() => {
    if (!listAppTestUsersQuery.data?.data) {
      return 0
    } else {
      return listAppTestUsersQuery.data.data.filter(
        (testUser) => testUser.assigned === true,
      )?.length
    }
  }, [listAppTestUsersQuery])

  const [checkedTestUsersArray, updateCheckedTestUsersArray] = useState([])

  const handleRemoveTestUser = (id) => {
    var index = checkedTestUsersArray.indexOf(id)
    if (index > -1) {
      checkedTestUsersArray.splice(index, 1)
      updateCheckedTestUsersArray([...checkedTestUsersArray])
    }
  }

  const testUsersToAssign = (testUserID, checked) => {
    if (checked && !checkedTestUsersArray.includes(testUserID)) {
      updateCheckedTestUsersArray((checkedTestUsersArray) => [
        ...checkedTestUsersArray,
        testUserID,
      ])
    } else {
      handleRemoveTestUser(testUserID)
    }
  }

  const updateAppCourseTestUsersMutation = useMutation(updateAppCourseTestUsers)

  const [loading, setLoading] = useState(false)

  const handleChange = async () => {
    try {
      setLoading(true)
      await updateAppCourseTestUsersMutation.mutateAsync({
        course_id: course_id,
        user_ids: checkedTestUsersArray,
      })
      setTimeout(async () => {
        await listAppTestUsersQuery.refetch()
        setLoading(false)
        openSnackBar({ message: "Test Users assigned successfully" })
      }, 300)
    } catch (err) {
      console.error("updateTestAppUserMutation", err.response.data)
      openSnackBar({ message: `${err.response.data.error}` })
      setLoading(false)
    }
  }

  return (
    <Page>
      <Box className={classes.searchBox}>
        <FormControlLabel
          control={
            <Checkbox
              edge="start"
              color="secondary"
              checked={showAssigned}
              onChange={() => setShowAssigned(!showAssigned)}
            />
          }
          label={
            <Typography>Show Assigned Users ({testUsersAssigned})</Typography>
          }
          labelPlacement="end"
          color="secondary"
        />
        <DebouncedSearch
          className={classes.search}
          placeholder="Search Test Users"
          onChange={(value) => setSearchValue(value)}
        />
      </Box>

      <Box className={classes.container}>
        <ListTitle
          list={[
            { name: "", size: "2%" },
            { name: "Name", size: "25%" },
            { name: "", size: "25%" },
            { name: "Email", size: "27%" },
            { name: "", size: "20%" },
            { name: "User ID", marginLeft: "%", size: "10%" },
            { name: "", size: "25%" },
            { name: "Assigned", size: "10%" },
            { name: "", size: "5%" },
          ]}
        />
        {testUsers?.map((testUser, i) => {
          return (
            <TestUserCard
              testUser={testUser}
              key={i}
              checked={checkedTestUsersArray.includes(testUser.id)}
              assignTestUsersFunc={testUsersToAssign}
            />
          )
        })}
      </Box>
      <Box className={classes.buttonContainer}>
        <PermissionsWrapper permissionGroup="admin">
          <LoaderButton
            working={loading}
            onClick={() => handleChange()}
            variant="contained"
            color="secondary"
            startIcon={<Add fontSize="small" />}
            style={{ height: "40px" }}
          >
            Assign to Course
          </LoaderButton>
        </PermissionsWrapper>
      </Box>
      <Router routes={routes} {...rest} />
    </Page>
  )
}
TestUser.propTypes = {
  routes: PropTypes.array,
  searchValue: PropTypes.string,
}
export default TestUser
